import store from '@/store'
import axios from 'axios'

export default axios.create({
  transformRequest: [...axios.default.defaults.transformRequest, function (data, headers) {
    headers['Authorization'] = 'Bearer ' + store.state.auth.token
    headers['Content-Type'] = 'application/vnd.api+json'
    return data
  }],
  transformResponse: [...axios.default.defaults.transformResponse, function (data) {
    if (data.errors) {
      const tokenExpired = data.errors.some(err => err.status === '401')
      tokenExpired && store.dispatch('auth/signOut')
    }
    return data
  }]
});